export default "__VITE_ASSET__CBuRqZy___"